import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
// import DateFnsUtils from '@date-io/date-fns';
import { TextField, Autocomplete, CircularProgress, Chip } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({ name, autocompletecallBack, autocompleteMatchingKey, defaultValues, ...other }) {
  const { control } = useFormContext();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const result = (await autocompletecallBack?.()) || [];
      setOptions(result);
      setLoading(false);
    })();
  }, [open]);

  if (other.type === 'dateTime') {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
           return(
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
            size={'small'}
              renderInput={(params) => <TextField size={'small'} {...params} />}
              // dateAdapter={DateFnsUtils}
              {...field}
              fullWidth
              value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
              error={!!error}
              helperText={error?.message}
              {...other}
            />
          </LocalizationProvider>
        )}}
      />
    );
  }

  if (other.type === 'date') {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              renderInput={(params) => <TextField size={'small'} {...params} />}
              // dateAdapter={DateFnsUtils}
              {...field}
              fullWidth
              value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
              error={!!error}
              helperText={error?.message}
              {...other}
            />
          </LocalizationProvider>
        )}
      />
    );
  }

  if (other.type === 'autocomplete') {
    const { onChange } = other;
    delete other.onChange;

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Autocomplete
            fullWidth
            open={open}
            onChange={onChange}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            isOptionEqualToValue={(option, value) =>
              option[autocompleteMatchingKey || 'name'] === value[autocompleteMatchingKey || 'name']
            }
            getOptionLabel={(option) =>
              option.code
                ? `${option[autocompleteMatchingKey]} - ${option.code}`
                : option[autocompleteMatchingKey || 'name']
            }
            options={options}
            loading={loading}
            renderInput={(params) => (
              <TextField
                {...params}
                {...field}
                error={!!error}
                helperText={error?.message}
                label={other.label}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && open ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        )}
      />
    );
  }

  if (other.type === 'autocompletemutiple') {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Autocomplete
            multiple
            freeSolo
            defaultValue={defaultValues}
            onChange={(event, newValue) => field.onChange(newValue)}
            options={options.map((option) => option)}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip {...getTagProps({ index })} key={option} size="small" label={option} />
              ))
            }
            renderInput={(params) => <TextField label={other.label} {...params} />}
          />
        )}
      />
    );
  }
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error?.message}
          {...other}
        />
      )}
    />
  );
}
